import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import ErrorLabel from '../../components/ErrorLabel/ErrorLabel';
import Alert from "../../components/Alert/Alert";
import axios from 'axios';
import css from '../Login/Login.module.scss'; // n.b. we're reusing Login styles

const PasswordReset = class extends Component {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();
    _isMounted = false;

    // ---------- state: ----------
    state = {
        shouldShowPasswordFields: false,
        shouldShowAlert: false,
        alertMessage: ''
    };

    // ---------- life cycle methods: ----------
    componentDidMount() {
        this._isMounted = true;
    };

    componentWillUnmount() {
        this._isMounted = false;
        this.source.cancel();
    };

    render () {
        return (
            <div className="App App--Login">
                <Alert showAlert={this.state.shouldShowAlert}>{this.state.alertMessage}</Alert>
                <div className={css.Login}>
                <img src="/assets/logo-V3.png" alt="V3 logo" />
                <h3 className="text-white mt-5 pt-4">Password Reset</h3>
                <Formik
                    initialValues={{
                        password: '',
                        repeatPassword: '',
                        resetToken: this.props.match.params.token
                    }}

                    validate={
                        (values)=> {
                            const errors = {};

                            if (!values.password.trim()) {
                                errors.password = 'Please Enter a Password';
                            } else if (values.password.length < 8) {
                                errors.password = "Password Must be Minimum 8 Characters Long";
                            }

                            if (!values.repeatPassword.trim()) {
                                errors.repeatPassword = 'Please Reenter Your Password';
                            } else if (values.repeatPassword !== values.password) {
                                errors.repeatPassword = 'Passwords Do Not Match';
                            }

                            return errors;
                        }
                    }

                    onSubmit={
                        (values) => {
                            axios.put(
                                '/user/reset/' + this.props.match.params.token + '/' + this.props.match.params.id,
                                values,
                                {
                                    cancelToken: this.source.token
                                })
                                .then((res) => {
                                    this.setState({
                                        alertMessage: 'Password updated successfully.',
                                        shouldShowAlert: true,
                                    });
                                })
                                .catch(err => {
                                    console.log(err);
                                    this.setState({
                                        alertMessage: 'Failed to set new password. The reset link may have expired.',
                                        shouldShowAlert: true,
                                    });
                                });
                        }
                    }
                >
                    <div>
                        <p className="mt-3">
                            Enter the password you want to use for your login.
                        </p>
                        <Form className="mt-4">
                            <div>
                                <div className="input-with-icons-container">
                                    <FontAwesomeIcon icon={faLock} />
                                    <Field className="input" type="text" name="password" placeholder="Password" />
                                </div>
                                <ErrorMessage name="password" component={ErrorLabel} />
                            </div>

                            <div className="mt-3">
                                <div className="input-with-icons-container">
                                    <FontAwesomeIcon icon={faLock} />
                                    <Field className="input" type="text" name="repeatPassword" placeholder="Repeat Password" />
                                </div>
                                <ErrorMessage name="repeatPassword" component={ErrorLabel} />
                            </div>

                            <div className="mt-4 d-flex flex-no-wrap align-items-center justify-content-between">
                                <Link to="/login" className="link-underline">Go Back</Link>
                                <button className={css.Login__BtnSubmit} type="submit">Reset Password</button>
                            </div>
                        </Form>
                    </div>
                </Formik>
                </div>
            </div>
        );
    }
};

export default PasswordReset;